// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../index';

export const SignatureStoneInputFragmentDoc = `
    fragment signatureStoneInput on CatalogueEngagementRingSignatureStone {
  __typename
  color {
    systemCode
  }
  crystal {
    systemCode
  }
  imageAsset {
    url
  }
  width
}
    `;